import { get } from 'lodash-es';
import config from 'configAlias';
import { getApiEndpoint } from 'srcAlias/utils/url';

export function buildApiCallParams({
  apiEndpointEnvVar,
  mockApiEndpoint,
  sessionId,
  selectTimeoutPath = 'apiCallTimeOut.eligiblityCall',
}) {
  const appConfig = get(config, 'appConfig', {});
  const headersDetails = {
    appEIMId: get(appConfig, 'appEIMId'),
    channelId: get(appConfig, 'channelId'),
    sessionId,
    countryCode: get(appConfig, 'countryCode'),
    groupMember: get(appConfig, 'groupMember'),
  };

  const apiDomain = getApiEndpoint();
  const apiEndpoint =
    process.env.REACT_APP_CREATE_MOCK_SERVER === 'true'
      ? mockApiEndpoint
      : process.env[apiEndpointEnvVar];
  const timeoutOptions = {
    min: get(appConfig, `${selectTimeoutPath}.customerMinTimeout`),
    max: get(appConfig, `${selectTimeoutPath}.customerMaxTimeout`),
    clientOverallMax: get(
      appConfig,
      `${selectTimeoutPath}.clientOverallMaxTimeout`
    ),
  };
  const finalUri = `${apiDomain}/${apiEndpoint}`;
  const method = 'GET';

  return {
    finalUri,
    method,
    headersDetails,
    timeoutOptions,
  };
}
